import React, { useEffect } from "react";
import Layout from "../../../../app/Layout";
import HeaderContent from "../../General/HeaderContent";
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  matriculaDiscenteActiva,
  obtenerMatriculasDiscente,
} from "../../../../actions/pagosActions";
import TablaOtroPagos from "../../../components/Finanzas/TablaOtrosPagos";
import CuotasDiscenteMatricula from "../../../components/Finanzas/CuotasDiscenteMatricula";
import ModalBasicwithRedux from "../../../../containers/ModalBasicwithRedux";
import { updateStateModalBasic } from "../../../../actions/modalActions";
import CambiarPlanMatricula from "../../Matriculas/CambiarPlanMatricula/CambiarPlanMatricula";

const ExaminarMatricula = () => {
  const dispatch = useDispatch();
  const datosFinanzasDiscente = useSelector(
    (state) => state.pagos.datosFinanzasDiscente.todo
  );

  const { usuario } = useSelector((state) => state.usuario);
const esOperaciones = usuario?.id_tp_nivel_usuario == 1;


  const params = new URLSearchParams(window.location.search);
  const tipo = params.get("q");
  const valor = params.get("value");
  const matricula = params.get("matricula");
  const matriculaCambio = datosFinanzasDiscente?.matriculas?.find(
  (item) => String(item.id_matricula) === String(matricula)
);

   console.log("MATRICULA PARA CAMBIO PLAN:", datosFinanzasDiscente?.matriculas?.[0]);

  
	const handleCambiarPlan = () => {
	  dispatch(updateStateModalBasic(
	  	<CambiarPlanMatricula
  proyectoId={matriculaCambio?.id_proyecto}
  planActual={matriculaCambio?.id_plan}
  nombrePlanActual={matriculaCambio?.nombre_plan}
  idMatricula={matriculaCambio?.id_matricula}
  dni={datosFinanzasDiscente.dni}
/>
	  )  );
	};

  useEffect(() => {
    const obtenerDatos = async () => {
      if (!Object.keys(datosFinanzasDiscente).length) {
        await dispatch(obtenerMatriculasDiscente(tipo, valor));
      }
      dispatch(matriculaDiscenteActiva(matricula));
    };
    obtenerDatos();
  }, []);

  return (
    <Layout>
      <div className="ExaminarMatricula">
		<ModalBasicwithRedux />
        <div className="d-flex justify-content-between align-items-center">
          <div className="ExaminarMatricula__head">
          	  <HeaderContent title="Registro de Pagos" />
    	  </div>
		  {esOperaciones ? (
  <button className="btn btn-primary d-flex align-items-center" onClick={handleCambiarPlan}>  
    <h5 className="mr-2 text-white">Cambiar plan</h5>
    <FontAwesomeIcon icon={faExchangeAlt} />
  </button>
) : null}

		</div>
        <div className="ExaminarMatricula__body">
          <CuotasDiscenteMatricula tipo={tipo} valor={valor} />
          <TablaOtroPagos idMatricula={matricula} tipo={tipo} valor={valor} />
        </div>
      </div>
    </Layout>
  );
};

export default ExaminarMatricula;
